import React from 'react'
import { axiosWithKey } from '~/axios'
import _ from 'lodash'

import RequireAuth from '~/components/RequireAuth'
import ListItem from '~/components/ListItem'

import { onUserAuth } from '~/redux/user/helpers'
import { getToken } from '~/redux/user/tokens'
import { getVideo } from '~/redux/video/helpers'

import { trackEvent } from '~/tools/analytics/cleverTap'
import userLanguageSelector from '~/tools/localization/userLanguageSelector'
import connect from "connect";
import userStore from '~/redux/user/store';

class Watchlist extends React.Component {
  constructor(){
    super()
    this.state = {
      items: [],
      deleteAllModal: false,
      fetching: false
    }

    this.moreToLoad = true

    this.getWatchlist = this.getWatchlist.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.clear = this.clear.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

    componentWillMount() {
      onUserAuth( user => { user && this.getWatchlist(user.userId) })
      window.document.addEventListener('scroll', _.debounce(this.handleScroll, 300));
    }

    componentDidUpdate(prevProps,prevState) {
      if(prevState.user && !this.state.user)
        this.setState({
          items: [],
          deleteAllModal: false,
          fetching: true
        })
    }

    
    handleScroll(){
      if (this.moreToLoad === false)
        return

      const body = window.document.body;
      const html = window.document.documentElement;
      const docHeight = Math.max(
        body.scrollHeight, 
        body.offsetHeight, 
        html.clientHeight, 
        html.scrollHeight, 
        html.offsetHeight
      )

      const windowBottom = window.innerHeight + window.pageYOffset;

      if (windowBottom >= docHeight - 300 && this.state.items.length >= 25)
        this.getWatchlist(this.state.user.userId)
    }

    toggleModal(){
      this.setState({ deleteAllModal: !this.state.deleteAllModal })
    }

    clear(){
      getToken(token => {
        axiosWithKey.delete(`${window.settings.apiBaseUrl}/user/queues`, {
          params: { userId: this.state.user.userId },
          headers: { 'Authorization': token },
        }).then(response => {
          if (response.status !== 200)
            return

          this.setState({
            items: [],
            deleteAllModal: !this.state.deleteAllModal
          })
        });
      })
    }

    deleteItem(item){
      getToken(token => {
        axiosWithKey.delete(`${window.settings.apiBaseUrl}/user/queues`, {
          params: {
            userId: this.state.user.userId,
            contentIds: item.id
          },
          headers: { 'Authorization': token },
        }).then(response => {
          if (response.status !== 200) return 

          this.trackItemDeletion(item)
          this.setState({ items: this.state.items.filter(l => l.id !== item.id) })
        });
      })
    }
    
    trackItemDeletion({ id, title, contentType }) {
      if (contentType !== 'VIDEO') {
        var removeFromQueueEventData = {
          contentId: id,
          contentTitle: title,
          contentType: contentType,
          showName: title,
        }
        trackEvent('Removed From Watchlist', removeFromQueueEventData)
        return
      }

      getVideo(id, res => {
        var { gist = {}, creditBlocks = [], categories =[] } = res.data.video
        categories.push(gist.primaryCategory)
        var removeFromQueueEventData = {
          contentId: gist.id,
          contentTitle: gist.title,
          contentType: gist.mediaType === 'EPISODIC' ? 'Episode' : 'Video',
          contentDuration: gist.runtime,
          playbackType: 'Streamed'
        }
        _.each(creditBlocks, ({ title, credits }) => {
          let trimmedTitle = title.trim().toLowerCase()
          if (trimmedTitle === 'director' || trimmedTitle === 'starring')
            removeFromQueueEventData.directorName = this.formatCredits(credits)
        })
        removeFromQueueEventData.contentGenre = categories.map(category => category.title).join(',')
        trackEvent('Removed From Watchlist', removeFromQueueEventData)
      })
    }

    formatCredits(credits) {
      return (credits && credits.length) 
        ? credits.map(it => it.title).join(',') 
        : ''
    }
    
    render(){
      const title = _.get(this.props.data, 'metadataMap.title')
      return(
        !window.SERVER_SIDE_RENDERING && (
          <RequireAuth user={this.state.user}>
            <ListItem 
              trayTitle={title || 'Watchlist'} 
              {...this.state} 
              deleteItem={this.deleteItem} 
              toggleModal={this.toggleModal} 
              clear={this.clear} 
              header={title || "Watchlist"}/>
          </RequireAuth>
        )
      )
    }

    getWatchlist(id){
      if (this.state.fetching || !this.moreToLoad)
        return 

      this.setState({ fetching: true })
      getToken(token => {
        axiosWithKey.get(`${window.settings.apiBaseUrl}/user/queues`, {
          params: {
            userId: id,
            offset: this.state.items.length,
            languageCode: userLanguageSelector()
          },
          headers:{ 'Authorization': token },
          contentType: 'application/json',
        }).then(res => {
          if (res && res.data.records) {
            this.setState({ items: this.concatMoreItems(res.data.records) })
          } else {
            this.moreToLoad = false
          }
        }).catch(error => {
          console.log(error);
          this.moreToLoad = false
        }).finally( () => {
          this.setState({ fetching: false })
        })
      })
    }

    concatMoreItems(items) {
      let newItems = _.reduce(items, (allItems, item, i) => {
        if (item.contentResponse)
          allItems.push(item.contentResponse.gist)
        return allItems
      }, [])

      let dupItemFound = _.some(newItems, newItem => {
        return _.some(this.state.items, item => newItem.id === item.id)
      })

      if (dupItemFound)
        this.moreToLoad = false
      
      return this.state.items.concat(newItems)
    }
}

connect(Watchlist, (state) => ({ user: state.user }), userStore)

export default Watchlist;